import gql from 'graphql-tag';

export const TeamMemberDetails = gql`
  fragment TeamMemberDetails on TeamMember {
    id
    email_address
    status
    has_password
    org_account {
      id
      username
    }
  }
`;
